export const maritalStatuses = ["single", "married", "widowed", "divorced", "commonLawPartner"] as const;
export type MaritalStatus = typeof maritalStatuses[number];
